import PageProtectedLayout from "../../components/Page/PageProtectedLayout";
import HealthCockpit from "./Cockpit/HealthCockpit";
import { useTranslation } from '../../language';


export default function DoctorNotesWelcome() {

    const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_preventive_health')}
      specify={t('page_sp_doctor_notes')}
      headlineMb={{ xs: 2, sm: 3 }}
      >

     <HealthCockpit section="doctor" />

    </PageProtectedLayout>

  );
}
